import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { FeatureCheckDirective } from './feature-check.directive';
import { AuthenticatedCheckDirective } from './authenticated-check.directive';

@NgModule({
    declarations: [
        NumbersOnlyDirective,
        FeatureCheckDirective,
        AuthenticatedCheckDirective
    ],
    imports: [CommonModule],
    exports: [
        NumbersOnlyDirective,
        FeatureCheckDirective,
        AuthenticatedCheckDirective
    ],
    providers: [],
})
export class DirectivesModule {}